export default "__VITE_ASSET__44bb4bbf__"